import { datadogRum } from '@datadog/browser-rum';
import { classifySessionError } from './classifySessionError';

export type FailureStage = 'otp_validation' | 'session_load';

const getHttpStatus = (error: unknown): number | undefined => {
  if (typeof error === 'object' && error !== null) {
    const response = (error as { response?: { status?: number } }).response;
    return response?.status;
  }
  return undefined;
};

/**
 * Registra falha de uma etapa do login (validação de OTP ou carregamento da
 * sessão) com contexto sanitizado. Não envia o erro Axios inteiro, config,
 * headers, token, OTP, senha, e-mail ou payload de login.
 *
 * A telemetria nunca pode impedir a autenticação: qualquer exceção do SDK é
 * engolida aqui.
 */
export const reportLoginFailure = (
  stage: FailureStage,
  error: unknown,
  durationMs: number,
): void => {
  const httpStatus = getHttpStatus(error);

  try {
    datadogRum.addError(new Error(`auth_${stage}_failed`), {
      stage,
      errorKind: classifySessionError(error),
      httpStatus: httpStatus || undefined,
      durationMs: Math.round(durationMs),
      // Pista, não teste de conectividade.
      onlineHint: navigator.onLine,
    });
  } catch {
    // Telemetria não pode impedir a autenticação.
  }
};
